import { Link } from "react-router-dom";
import { X, FolderKanban, Calendar, NotebookPen, UsersRound, Settings, MessageSquarePlus, Download, Bell, Target, Database } from "lucide-react";
import FeedbackModal from "@/app/FeedbackModal";
import InstallPrompt from "@/app/InstallPrompt";
import { useState } from "react";

const LINKS = [
  { to: "/app/goals", label: "Goals", icon: Target },
  { to: "/app/projects", label: "Projects", icon: FolderKanban },
  { to: "/app/calendar", label: "Calendar", icon: Calendar },
  { to: "/app/data", label: "Data", icon: Database },
  { to: "/app/meeting", label: "Meeting Assist", icon: NotebookPen },
  { to: "/app/settings/team", label: "Team", icon: UsersRound },
  { to: "/app/settings", label: "Settings", icon: Settings },
  { to: "/app/settings/notifications", label: "Notifications", icon: Bell },
];

export default function MobileMoreSheet({ open, onClose }) {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [installOpen, setInstallOpen] = useState(false);
  if (!open) return null;
  return (
    <>
      <div className="fixed inset-0 z-40 flex flex-col justify-end lg:hidden" data-testid="mobile-more-sheet">
        <button aria-label="Close" onClick={onClose} className="flex-1 bg-black/50 backdrop-blur-sm" />
        <div className="max-h-[80vh] overflow-y-auto rounded-t-3xl bg-card p-5 pb-[max(env(safe-area-inset-bottom),20px)]">
          <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-border" />
          <div className="mb-3 flex items-center justify-between">
            <p className="font-display text-lg font-semibold">More</p>
            <button onClick={onClose} data-testid="mobile-more-close" className="text-muted-foreground hover:text-foreground">
              <X className="h-5 w-5" />
            </button>
          </div>
          <ul className="grid grid-cols-2 gap-2">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  onClick={onClose}
                  data-testid={`mobile-more-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex items-center gap-2 rounded-2xl border border-border bg-background px-3 py-3 text-sm font-medium"
                >
                  <l.icon className="h-4 w-4 text-brand-teal" />
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <button
                onClick={() => { setFeedbackOpen(true); }}
                data-testid="mobile-more-feedback"
                className="flex w-full items-center gap-2 rounded-2xl border border-border bg-background px-3 py-3 text-sm font-medium"
              >
                <MessageSquarePlus className="h-4 w-4 text-brand-orange" /> Feedback
              </button>
            </li>
            <li>
              <button
                onClick={() => { setInstallOpen(true); }}
                data-testid="mobile-more-install"
                className="flex w-full items-center gap-2 rounded-2xl border border-border bg-background px-3 py-3 text-sm font-medium"
              >
                <Download className="h-4 w-4 text-brand-blue" /> Install Workspace
              </button>
            </li>
          </ul>
        </div>
      </div>
      <FeedbackModal open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
      <InstallPrompt open={installOpen} onClose={() => setInstallOpen(false)} />
    </>
  );
}
